/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PccPicklistResponse } from './PccPicklistResponse';
import {
    PccPicklistResponseFromJSON,
    PccPicklistResponseFromJSONTyped,
    PccPicklistResponseToJSON,
} from './PccPicklistResponse';

/**
 * 
 * @export
 * @interface GetPccPicklist200Response
 */
export interface GetPccPicklist200Response {
    /**
     * 
     * @type {PccPicklistResponse}
     * @memberof GetPccPicklist200Response
     */
    data?: PccPicklistResponse;
}

/**
 * Check if a given object implements the GetPccPicklist200Response interface.
 */
export function instanceOfGetPccPicklist200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetPccPicklist200ResponseFromJSON(json: any): GetPccPicklist200Response {
    return GetPccPicklist200ResponseFromJSONTyped(json, false);
}

export function GetPccPicklist200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPccPicklist200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PccPicklistResponseFromJSON(json['data']),
    };
}

export function GetPccPicklist200ResponseToJSON(value?: GetPccPicklist200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PccPicklistResponseToJSON(value.data),
    };
}

